<template>
  <nav class="tableheaderTitle d-flex justify-center align-center">
    <v-row>
      <v-col cols="12" class="pt-0 pb-0">
        <v-list color="transparent pt-0 pb-0">
          <v-list-item class="px-0">
            <v-list-item-content>
              <v-list-item-title
                class="headline primary--text font-weight-black"
              >
                <span v-if="title">
                  {{ title }}
                </span>
                <span v-if="title === null">
                  <v-skeleton-loader
                    max-width="300"
                    type="heading"
                  ></v-skeleton-loader>
                </span>
              </v-list-item-title>
            </v-list-item-content>
            <v-list-item-action>
              <div v-if="!$vuetify.breakpoint.mobile" class="d-none d-sm-flex">
                <v-btn
                  v-if="isFilterOn && !hideRemoveFilterButton"
                  @click="removeFilter"
                  color="grey"
                  outlined
                  depressed
                >
                  <span class="d-none d-sm-block">Slett filter</span>
                </v-btn>

                <div v-for="(button, index) in btns" :key="index">
                  <v-btn
                    v-if="!button.hide"
                    class="ml-2"
                    depressed
                    :disabled="button.disabled"
                    :outlined="button.outlined"
                    :color="button.color"
                    @click="returnBtn(button)"
                  >
                    {{ button.name }}
                  </v-btn>
                </div>

                <div v-if="exportName">
                  <v-btn
                    v-if="exportName"
                    class="ml-2"
                    depressed
                    color="success"
                    @click="showExport = true"
                  >
                    Eksporter
                  </v-btn>
                </div>
              </div>

              <div v-if="$vuetify.breakpoint.mobile">
                <v-menu buttom offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="grey"
                      depressed
                      height="40"
                      outlined
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon class="ml-0 ml-sm-1" small
                        >mdi-dots-vertical</v-icon
                      >
                    </v-btn>
                  </template>

                  <v-list dense nav>
                    <v-list-item
                      v-if="isFilterOn && !hideRemoveFilterButton"
                      @click="removeFilter"
                      link
                    >
                      <v-list-item-content>
                        <v-list-item-title>Slett filter</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>

                    <v-list-item
                      v-if="exportName"
                      @click="showExport = true"
                      link
                    >
                      <v-list-item-content>
                        <v-list-item-title>Eksporter</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-col>
    </v-row>
    <ExportTable
      v-model="showExport"
      :headers="headerData"
      :items="items"
      :exportName="exportName"
      :removeExportButton="removeExportButton"
      @exportAll="exportAll"
    />
    <ChangeColumnDialog
      v-model="showColumnChange"
      :headers="headerData"
      :items="items"
    />
  </nav>
</template>

<script>
import ExportTable from "@/components/shared/table/ExportTable";
import ChangeColumnDialog from "@/components/shared/table/ChangeColumnDialog";
export default {
  props: {
    header: {
      default: [],
    },
    title: {
      requiered: true,
    },
    items: {
      default: [],
    },
    "export-name": {
      default: null,
    },
    tableId: {
      requiered: true,
    },
    buttons: {
      default: () => [],
    },
    exportName: {
      default: null,
    },
    isFilterOn: {
      type: Boolean,
      default: false,
    },
    removeExportButton: {
      type: Boolean,
      default: false,
    },
    hideRemoveFilterButton: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showExport: false,
      showColumnChange: false,
      search: "",
    };
  },
  methods: {
    removeFilter() {
      this.$emit("removeFilter");
    },
    returnBtn(data) {
      if (data.emitName === "eksport") {
        this.showExport = true;
      } else {
        this.$emit("returnBtn", data);
      }
    },
    exportAll(data) {
      this.$emit("exportAll", data);
    },
  },
  computed: {
    headerData: {
      get() {
        return this.header;
      },
      set(value) {
        this.$emit("update:header", value);
      },
    },
    btns() {
      return this.buttons;
    },
  },

  components: {
    ExportTable,
    ChangeColumnDialog,
  },
};
</script>

<style lang="scss">
.tableheaderTitle {
  flex-grow: 1;
}
</style>
